const CALENDAR_LABELS = {
  vi: {
    weekdays: {
      sunday: 'CN',
      monday: 'T2',
      tuesday: 'T3',
      wednesday: 'T4',
      thursday: 'T5',
      friday: 'T6',
      saturday: 'T7',
    },
    hours: 'Giờ',
    minutes: 'Phút',
    seconds: 'Giây',
  },
  km: {
    weekdays: {
      sunday: 'អាទិ',
      monday: 'ចន្ទ',
      tuesday: 'អង្គ',
      wednesday: 'ពុធ',
      thursday: 'ព្រហ',
      friday: 'សុក្រ',
      saturday: 'សៅរ៍',
    },
    weekdaysFull: {
      sunday: 'អាទិត្យ',
      monday: 'ច័ន្ទ',
      tuesday: 'អង្គារ',
      wednesday: 'ពុធ',
      thursday: 'ព្រហស្បតិ៍',
      friday: 'សុក្រ',
      saturday: 'សៅរ៍',
    },
    hours: 'ម៉ោង',
    minutes: 'នាទី',
    seconds: 'វិនាទី',
  },
  en: {
    weekdays: {
      sunday: 'Su',
      monday: 'Mo',
      tuesday: 'Tu',
      wednesday: 'We',
      thursday: 'Th',
      friday: 'Fr',
      saturday: 'Sa',
    },
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
  },
  cn: {
    weekdays: {
      sunday: '日',
      monday: '一',
      tuesday: '二',
      wednesday: '三',
      thursday: '四',
      friday: '五',
      saturday: '六',
    },
    hours: '小时',
    minutes: '分钟',
    seconds: '秒',
  },
}

const WEEKDAY_KEYS = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
]

const normalizeLanguage = language => {
  const normalizedLanguage = String(language || 'km').toLowerCase()

  if (normalizedLanguage.startsWith('vi')) return 'vi'
  if (normalizedLanguage.startsWith('km')) return 'km'
  if (normalizedLanguage.startsWith('cn') || normalizedLanguage.startsWith('zh')) return 'cn'
  return 'en'
}

export const getCalendarLocale = ({language = 'km', t} = {}) => {
  const labels = CALENDAR_LABELS[normalizeLanguage(language)]
  const translate = typeof t === 'function' ? t : key => key

  return {
    dateRangePickerLocale: {
      ...labels.weekdays,
      ok: translate('confirm'),
      today: translate('today'),
      yesterday: translate('yesterday'),
      hours: labels.hours,
      minutes: labels.minutes,
      seconds: labels.seconds,
      formattedMonthPattern: 'MMM yyyy',
      formattedDayPattern: 'dd MMM yyyy',
      last7Days: translate('7_days_ago'),
    },
    formatWeekday: date => {
      const normalizedDate = date instanceof Date ? date : new Date(date)

      if (Number.isNaN(normalizedDate.getTime())) return ''

      const weekdayLabels = labels.weekdaysFull || labels.weekdays
      return weekdayLabels[WEEKDAY_KEYS[normalizedDate.getDay()]]
    },
  }
}
